import React, { useState, useEffect } from "react";
import ContactDataService from "../services/ContactService";

//tab
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';

import Button from '@mui/material/Button';
import Accordion from "./Accordion";

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';


const AddContact = () => {
    const initialContactState = {
        persona_id: null,
        primo_contatto: null,
        titolo: "",
        categoria: "",
        nome: "",
        cognome: "",
        attacco_lettera: "",
        indirizzo: "",
        civico: "",
        citta: "",
        cap: 0,
        provincia: "",
        telefono: "",
        cellulare: "",
        societa: "",
        email: "",
        sesso: "",
        privacy: "",
        provenienza: "",
        data_nascita: null,
        luogo_nascita: "",
        eta: 0,
        codice_fiscale: "",
        partita_iva: "",
        legame: "",
        tipologia: "",
        donazione_id: 0,
        ragione_sociale: "",
        fonte: "",
        riconsocimento_invalidita: "",
        perc_invalidita: 0,
        data_colloquio: null,
        data_socio: null,
        iscrizione_collocamento: "",
        pensione: ""
    };
    const [Contact, setContact] = useState(initialContactState);

    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleInputChange = event => {
        if (initialContactState.persona_id) {
            setContact(initialContactState)
        }
        const { name, value } = event.target;
        setContact({ ...Contact, [name]: value });
    };

    const saveContact = () => {
        var data = {
            primo_contatto: Contact.primo_contatto,
            titolo: Contact.titolo,
            categoria: Contact.categoria,
            nome: Contact.nome,
            cognome: Contact.cognome,
            attacco_lettera: Contact.attacco_lettera,
            indirizzo: Contact.indirizzo,
            civico: Contact.civico,
            citta: Contact.citta,
            cap: Contact.cap,
            provincia: Contact.provincia,
            telefono: Contact.telefono,
            cellulare: Contact.cellulare,
            societa: Contact.societa,
            email: Contact.email,
            sesso: Contact.sesso,
            privacy: Contact.privacy,
            provenienza: Contact.provenienza,
            data_nascita: Contact.data_nascita,
            luogo_nascita: Contact.luogo_nascita,
            eta: Contact.eta,
            codice_fiscale: Contact.codice_fiscale,
            partita_iva: Contact.partita_iva,
            legame: Contact.legame,
            tipologia: Contact.tipologia,
            donazione_id: Contact.donazione_id,
            ragione_sociale: Contact.ragione_sociale,
            fonte: Contact.fonte,
            riconsocimento_invalidita: Contact.riconsocimento_invalidita,
            perc_invalidita: Contact.perc_invalidita,
            data_colloquio: Contact.data_colloquio,
            data_socio: Contact.data_socio,
            iscrizione_collocamento: Contact.iscrizione_collocamento,
            pensione: Contact.pensione
        };

        ContactDataService.create(data)
            .then(response => {
                setContact({
                    persona_id: response.data.persona_id,
                    primo_contatto: response.data.primo_contatto,
                    titolo: response.data.titolo,
                    categoria: response.data.categoria,
                    nome: response.data.nome,
                    cognome: response.data.cognome,
                    attacco_lettera: response.data.attacco_lettera,
                    indirizzo: response.data.indirizzo,
                    civico: response.data.civico,
                    citta: response.data.citta,
                    cap: response.data.cap,
                    provincia: response.data.provincia,
                    telefono: response.data.telefono,
                    cellulare: response.data.cellulare,
                    societa: response.data.societa,
                    email: response.data.email,
                    sesso: response.data.sesso,
                    privacy: response.data.privacy,
                    provenienza: response.data.provenienza,
                    data_nascita: response.data.data_nascita,
                    luogo_nascita: response.data.luogo_nascita,
                    eta: response.data.eta,
                    codice_fiscale: response.data.codice_fiscale,
                    partita_iva: response.data.partita_iva,
                    legame: response.data.legame,
                    tipologia: response.data.tipologia,
                    donazione_id: response.data.donazione_id,
                    ragione_sociale: response.data.ragione_sociale,
                    fonte: response.data.fonte,
                    riconsocimento_invalidita: response.riconsocimento_invalidita,
                    perc_invalidita: response.perc_invalidita,
                    data_colloquio: response.data_colloquio,
                    data_socio: response.data_socio,
                    iscrizione_collocamento: response.iscrizione_collocamento,
                    pensione: response.pensione
                });
                console.log(response.data);
            })
            .catch(e => {
                console.log(e);
            });
    };

    return (
        <TabContext value={(value) ? value : "1"} >
            <Box sx={{ width: '100%', bgcolor: 'background.paper' }}>
                <TabList onChange={handleChange} aria-label="lab API tabs example" centered >
                    <Tab label="Anagrafica" value="1" />
                    <Tab label="Contatti" value="2" />
                    <Tab label="Indirizzo" value="3" />
                    <Tab label="Donazioni" value="4" />
                    <Tab label="Info aggiuntive" value="5" />
                </TabList>

                <TabPanel value="1">
                    <TextField id="outlined-basic" label="Titolo" name="titolo" variant="outlined" style={{ marginBottom: "20px", marginRight: "20px" }} onChange={handleInputChange} />
                    <TextField id="outlined-basic" label="Nome" name="nome" variant="outlined" style={{ marginBottom: "20px", marginRight: "20px" }} onChange={handleInputChange} />
                    <TextField id="outlined-basic" label="Cognome" name="cognome" variant="outlined" style={{ marginBottom: "20px", marginRight: "20px" }} onChange={handleInputChange} />
                    <TextField id="outlined-basic" label="Sesso" variant="outlined" name="sesso" style={{ marginBottom: "20px", marginRight: "20px" }} onChange={handleInputChange} />
                    <TextField id="outlined-basic" label="Data di nascita" variant="outlined" InputLabelProps={{ shrink: true }} type="date" name="data_nascita" style={{ marginBottom: "20px", marginRight: "20px" }} onChange={handleInputChange} />
                    <TextField id="outlined-basic" label="Luogo di nascita" variant="outlined" name="luogo_nascita" style={{ marginBottom: "20px", marginRight: "20px" }} onChange={handleInputChange} />
                    <TextField id="outlined-basic" label="Codice fiscale" variant="outlined" name="codice_fiscale" style={{ marginBottom: "20px", marginRight: "20px" }} onChange={handleInputChange} />
                </TabPanel>
                <TabPanel value="2">
                    <TextField id="outlined-basic" label="Telefono" variant="outlined" name="telefono" style={{ marginBottom: "20px", marginRight: "20px" }} onChange={handleInputChange} />
                    <TextField id="outlined-basic" label="Cellulare" variant="outlined" name="cellulare" style={{ marginBottom: "20px", marginRight: "20px" }} onChange={handleInputChange} />
                    <TextField id="outlined-basic" label="Email" variant="outlined" name="email" style={{ marginBottom: "20px", marginRight: "20px" }} onChange={handleInputChange} />
                </TabPanel>
                <TabPanel value="3">
                    <TextField id="outlined-basic" label="Indirizzo" variant="outlined" name="indirizzo" style={{ marginBottom: "20px", marginRight: "20px" }} onChange={handleInputChange} />
                    <TextField id="outlined-basic" label="Civico" variant="outlined" name="civico" style={{ marginBottom: "20px", marginRight: "20px" }} onChange={handleInputChange} />
                    <TextField id="outlined-basic" label="Provincia" variant="outlined" name="email" style={{ marginBottom: "20px", marginRight: "20px" }} onChange={handleInputChange} />
                    <TextField id="outlined-basic" label="Cap" variant="outlined" name="cap" style={{ marginBottom: "20px", marginRight: "20px" }} onChange={handleInputChange} />
                </TabPanel>
                <TabPanel value="4">
                    <Accordion />
                </TabPanel>
                <TabPanel value="5">
                    <FormControl style={{ marginBottom: "20px", marginRight: "20px", minWidth: 120 }}>
                        <InputLabel id="demo-simple-select-label">Categoria</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Categoria"
                            name="categoria"
                            onChange={handleInputChange}
                        >
                            <MenuItem value={"Dipendente"}>Dipendente</MenuItem>
                            <MenuItem value={"Volontario"}>Volontario</MenuItem>
                            <MenuItem value={"Socio"}>Socio</MenuItem>
                            <MenuItem value={"Donatore"}>Donatore</MenuItem>
                            <MenuItem value={"Socio fondatore"}>Socio fondatore</MenuItem>
                            <MenuItem value={"Azienda"}>Azienda</MenuItem>
                            <MenuItem value={"Fondazioni"}>Fondazioni</MenuItem>
                            <MenuItem value={"Enti pubblici"}>Enti pubblici</MenuItem>
                        </Select>
                    </FormControl>
                    <TextField id="outlined-basic" label="Primo contatto" variant="outlined" type="date" InputLabelProps={{ shrink: true }} name="primo_contatto" style={{ marginBottom: "20px", marginRight: "20px" }} />
                    <TextField id="outlined-basic" label="Società" variant="outlined" name="societa" style={{ marginBottom: "20px", marginRight: "20px" }} />
                    <TextField id="outlined-basic" label="Provenienza" variant="outlined" name="provenienza" style={{ marginBottom: "20px", marginRight: "20px" }} />
                    <TextField id="outlined-basic" label="Privacy" variant="outlined" name="privacy" style={{ marginBottom: "20px", marginRight: "20px" }} />
                    <TextField id="outlined-basic" label="Partita Iva" variant="outlined" name="partita_iva" style={{ marginBottom: "20px", marginRight: "20px" }} />
                    <TextField id="outlined-basic" label="Legame" variant="outlined" name="legame" style={{ marginBottom: "20px", marginRight: "20px" }} />
                    <TextField id="outlined-basic" label="Tipologia" variant="outlined" name="tipologia" style={{ marginBottom: "20px", marginRight: "20px" }} />
                    <TextField id="outlined-basic" label="Fonte" variant="outlined" name="fonte" style={{ marginBottom: "20px", marginRight: "20px" }} />
                    <TextField id="outlined-basic" label="Ragione Sociale" variant="outlined" name="ragione_sociale" style={{ marginBottom: "20px", marginRight: "20px" }} />
                </TabPanel>
                <Button variant="contained" sx={{ margin: "20px" }} onClick={saveContact}>Salva</Button>
            </Box>
        </TabContext>
    );
};

export default AddContact;
